<ng-select
  class="list-dropdown"
  [typeahead]="search$"
  placeholder="Type item name..."
  [loading]="isLoading"
  [clearable]="false"
  [markFirst]="true"
  autofocus
  (change)="onChange($event)"
  (keyup.esc)="cancel.emit()"
  (blur)="cancel.emit()"
  #select
  ccNgSelectFirstFocused
>
  <ng-template ng-loadingspinner-tmp></ng-template>
  <ng-option
    *ngFor="let listItem of listItems$ | async"
    [value]="listItem.value"
    [innerHTML]="highlightMatches(search$ | async, listItem.id, listItem.value)"
  ></ng-option>
</ng-select>
